import { render, staticRenderFns } from "./exchangeCode.vue?vue&type=template&id=b1614d9c&scoped=true&"
import script from "./exchangeCode.vue?vue&type=script&lang=ts&"
export * from "./exchangeCode.vue?vue&type=script&lang=ts&"
import style0 from "./exchangeCode.vue?vue&type=style&index=0&id=b1614d9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1614d9c",
  null
  
)

export default component.exports